'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

const SCROLL_TARGET_ID = 'why-choose';

export default function ScrollIndicator() {
  const handleClick = () => {
    const el = document.getElementById(SCROLL_TARGET_ID);
    el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section
      className="flex min-h-[10vh] flex-col items-center justify-center bg-background py-6 sm:py-8"
      aria-label="Scroll to see more"
    >
      <button
        type="button"
        onClick={handleClick}
        className="flex flex-col items-center gap-2 text-foreground transition-all duration-300 hover:gap-3 hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background"
        aria-label="Scroll to Why Choose Freshlymade"
      >
        <span className="text-xs font-semibold uppercase tracking-[0.25em]">Scroll</span>
        <Icon
          name="ChevronDownIcon"
          size={28}
          className="animate-[bounce_2s_ease-in-out_infinite] text-foreground"
          aria-hidden
        />
      </button>
    </section>
  );
}
